import React from "react";
import ServicesCard from "./ServicesCard";
import { Container, Heading, SimpleGrid } from "@chakra-ui/react";
import { CgWebsite } from "react-icons/cg";
import { MdOutlineDesignServices } from "react-icons/md";
import { SearchIcon } from "@chakra-ui/icons";
import { SiResearchgate } from "react-icons/si";
const Services = () => {
  return (
    <Container maxW={"container.lg"} my="6">
      <Heading
        size={"md"}
        className="text-center uppercase text-2xl mt-12 mb-2"
      >
        What I can Offer!!
      </Heading>
      <hr className="mb-6 mx-60 border-teal-400" />
      <SimpleGrid columns={[1, 2, 3, 4]} spacing="2">
        <ServicesCard
          icon={<MdOutlineDesignServices />}
          title="Website Design"
          text={
            "I Can Design front end website. also make it very gorgeous and beautiful if i got some time."
          }
          rating="4.9"
        />
        <ServicesCard
          sp={"bg-teal-300 dark:bg-red-500"}
          icon={<CgWebsite />}
          title="FullStack Website "
          text={
            "I can Develop a fullstack website from backend to client end . fully functional. no doubt!"
          }
          rating="4.9"
        />

        <ServicesCard
          icon={<SiResearchgate />}
          title="Research Assistant"
          text={
            "I provide support to research teams who are conducting experiments or gathering and analysing data."
          }
          rating="4.9"
        />
        <ServicesCard
          icon={<SearchIcon />}
          title="SEO"
          text={
            "I make your website more visible, and that means more traffic and more opportunities to convert prospects into customers."
          }
          rating="4.9"
        />
      </SimpleGrid>
    </Container>
  );
};

export default Services;
